module.exports = __webpack_public_path__ + "static/media/lifestyle2-large.af728ea8.jpg";